<script>
export default {
    name: 'ServicePlanFeatureEntity',
};
</script>

<script setup>
import { computed, toRef } from 'vue';
import i18n from '@/plugins/i18n.ts';
import { FIELD } from '@/components/payments/components/service-plan/components/features/constants';
import useFeature from '@/components/payments/components/service-plan/components/features/composables/use-feature';
import ServicePlanFeatureElementsValue from '@/components/payments/components/service-plan/components/features/components/elements/value';

const props = defineProps({
    feature: {
        type:     Object,
        required: true,
    },
});

const { exclude } = useFeature(toRef(props, 'feature'));

const formatted = computed(() => {
    const excludeObjects = Object.values(exclude.value);

    if (!excludeObjects.length) return i18n.t('payment.servicePlan.feature.object.all');

    return i18n.t('payment.servicePlan.feature.object.exclude', {
        exclude: excludeObjects.join(', '),
    });
});
</script>

<template>
    <service-plan-feature-elements-value
        :name="feature[FIELD.NAME]"
        :value="formatted"
    />
</template>
